import {dateTime} from "services/date";
import {Event} from "types/Event";
import {RRule} from "rrule";

/**
 * Transform the given event by deserializing object properties
 *
 * @internal
 * @param event
 */
export default function deserializeEvent(event: any): Event {
    event.recurrence = event.recurrence ? RRule.fromString(event.recurrence) : null
    event.starts_at = dateTime(event.starts_at)
    event.starts_at_local = dateTime(event.starts_at_local)
    event.ends_at = dateTime(event.ends_at)
    event.ends_at_local = dateTime(event.ends_at_local)
    // event.duration = duration(event.duration)
    event.published_at = dateTime(event.published_at)
    event.created_at = dateTime(event.created_at)
    event.updated_at = dateTime(event.updated_at)

    return event;
}